<mat-toolbar class="toolbar">
    <button mat-icon-button class="menu-button" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
    </button>

    <div class="toolbarLogo">
        <a href="/">
            <img src="assets/images/logo.svg" alt="Workbi Logo">
        </a>
    </div>

    <nav class="toolbarNav">
        <a href="/" class="nav-link">Inicio</a>
        <a href="/quienes-somos" class="nav-link">Quiénes Somos</a>
    </nav>

    <div class="toolbarButtons">
        <button mat-flat-button class="downloadBtn" [matMenuTriggerFor]="downloadMenu">
            <span>Descargar App</span>
            <mat-icon class="arrow-icon">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #downloadMenu="matMenu" xPosition="before" class="download-app-menu">
            <a mat-menu-item href="https://play.google.com/store/apps/details?id=co.workbi&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                <div class="menu-store-item">
                    <img src="assets/images/google-play.svg" alt="Google Play" class="store-menu-icon">
                    <div class="store-text">
                        <span class="store-label">Google Play</span>
                        <small class="store-sub">Para Android</small>
                    </div>
                </div>
            </a>
            <a mat-menu-item href="https://apps.apple.com/co/app/workbi/id6756087985?l=en-GB" target="_blank" rel="noopener noreferrer">
                <div class="menu-store-item">
                    <img src="assets/images/download-ios.svg" alt="App Store" class="store-menu-icon">
                    <div class="store-text">
                        <span class="store-label">App Store</span>
                        <small class="store-sub">Para iOS / iPhone</small>
                    </div>
                </div>
            </a>
        </mat-menu>
    </div>
</mat-toolbar>